/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import * as Messages from './RebatePgmConstants';
import NumberFormatCustom from '../../../SharedModules/NumberFormat/NumberFormat';
import {
  RX_WITHOUT,
  TWO_DECIMAL_REGEX,
} from '../../../SharedModules/AppConstants';

const AuditsTab = (props) => {
  const {
    defAudit,
    data,
    changeHandler,
    flderr,
    blurHandler,
    plan,
    isEnablebyRole,
  } = props;

  return (
    <>
      <div className="default-wrap">
        <fieldset className="custom-fieldset">
          <legend className="same-font-family">Claim</legend>
          <div className="off">
            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            value={data?.CUNAtestOnInd === 1}
                            checked={data?.CUNAtestOnInd === 1}
                            onChange={(e, val) =>
                              changeHandler(val, 'CUNAtestOnInd', true)
                            }
                          />
                        }
                        data-testid="CUNAtestOnInd"
                        disabled={
                          defAudit || plan === 'SUPP' || !isEnablebyRole
                        }
                        label="Units greater than % average for NDC for previous quarter"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="percent_average_units"
                      label="Percent Average Units"
                      fullWidth
                      placeholder=""
                      value={data?.CUNAtestAmt}
                      className="mandate-fields"
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value && value.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(value))
                            changeHandler(value, 'CUNAtestAmt');
                          else return false;
                        } else if (RX_WITHOUT.test(value))
                          changeHandler(value, 'CUNAtestAmt');
                        else return false;
                      }}
                      data-testid="CUNAtestAmt"
                      disabled={
                        defAudit ||
                        !data.CUNAtestOnInd ||
                        plan === 'SUPP' ||
                        !isEnablebyRole
                      }
                      inputProps={{ maxLength: 30, id: 'percentAverageUnits' }}
                      InputLabelProps={{ shrink: true }}
                      onBlur={(e) => blurHandler(e.target.value, 'CUNAtestAmt')}
                      helperText={
                        flderr?.CUNAtestAmtErr ? Messages.AVG_PER_REQ_ERR : null
                      }
                      error={flderr?.CUNAtestAmtErr}
                      InputProps={{
                        inputProps: {
                          maxlength: 30,
                          style: { textAlign: 'right' },
                        },
                        min: 0,
                        endAdornment: (
                          <InputAdornment className="suffix-symbol">
                            %
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            value={data?.CREStestOnInd === 1}
                            checked={data?.CREStestOnInd === 1}
                            onChange={(e, val) =>
                              changeHandler(val, 'CREStestOnInd', true)
                            }
                          />
                        }
                        data-testid="CREStestOnInd"
                        disabled={
                          defAudit || plan === 'SUPP' || !isEnablebyRole
                        }
                        label="Reimbursed = Submitted"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6" />
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            value={data?.CAEStestOnInd === 1}
                            checked={data?.CAEStestOnInd === 1}
                            onChange={(e, val) =>
                              changeHandler(val, 'CAEStestOnInd', true)
                            }
                          />
                        }
                        data-testid="CAEStestOnInd"
                        disabled={
                          defAudit || plan === 'SUPP' || !isEnablebyRole
                        }
                        label="Allowed amount exceeds % submitted amount"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="percent_submitted_amount1"
                      label="Percent Submitted Amount"
                      fullWidth
                      placeholder=""
                      className="mandate-fields"
                      value={data?.CAEStestAmt}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value && value.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(value))
                            changeHandler(value, 'CAEStestAmt');
                          else return false;
                        } else if (RX_WITHOUT.test(value))
                          changeHandler(value, 'CAEStestAmt');
                        else return false;
                      }}
                      data-testid="CAEStestAmt"
                      disabled={
                        defAudit ||
                        !data.CAEStestOnInd ||
                        plan === 'SUPP' ||
                        !isEnablebyRole
                      }
                      InputProps={{
                        inputProps: {
                          maxlength: 15,
                          style: { textAlign: 'right' },
                        },
                        endAdornment: (
                          <InputAdornment className="prefix-symbol pr-2">
                            %
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        maxLength: 20,
                        id: 'percentSubmittedAmount',
                      }}
                      InputLabelProps={{ shrink: true }}
                      onBlur={(e) => blurHandler(e.target.value, 'CAEStestAmt')}
                      helperText={
                        flderr?.CAEStestAmtErr ? Messages.PER_SUB_ERR : null
                      }
                      error={flderr?.CAEStestAmtErr}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            value={data?.CSRAtestOnInd=== 1}
                            checked={data?.CSRAtestOnInd === 1}
                            onChange={(e, val) =>
                              changeHandler(val, 'CSRAtestOnInd', true)
                            }
                            data-testid="CSRAtestOnInd"
                            disabled={
                              defAudit || plan === 'SUPP' || !isEnablebyRole
                            }
                          />
                        }
                        label="Reimbursed amount less than % submitted"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="percent_submitted_amount2"
                      label="Percent Submitted Amount"
                      fullWidth
                      value={data?.CSRAtestAmt}
                      className="mandate-fields"
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value && value.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(value))
                            changeHandler(value, 'CSRAtestAmt');
                          else return false;
                        } else if (RX_WITHOUT.test(value))
                          changeHandler(value, 'CSRAtestAmt');
                        else return false;
                      }}
                      data-testid="CSRAtestAmt"
                      disabled={
                        defAudit ||
                        !data.CRLAtestOnInd ||
                        plan === 'SUPP' ||
                        !isEnablebyRole
                      }
                      InputProps={{
                        inputProps: {
                          maxlength: 15,
                          style: { textAlign: 'right' },
                        },
                        endAdornment: (
                          <InputAdornment className="prefix-symbol pr-2">
                            %
                          </InputAdornment>
                        ),
                        id: 'percentAllowedAmount',
                      }}
                      InputLabelProps={{ shrink: true }}
                      onBlur={(e) => blurHandler(e.target.value, 'CRLAtestAmt')}
                      helperText={
                        flderr?.CRLAtestAmtErr ? Messages.PER_ALLOW_ERR : null
                      }
                      error={flderr?.CRLAtestAmtErr}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            value={data?.CRLAtestOnInd === 1}
                            checked={data?.CRLAtestOnInd === 1}
                            onChange={(e, val) =>
                              changeHandler(val, 'CRLAtestOnInd', true)
                            }
                            data-testid="CRLAtestOnInd"
                            disabled={
                              defAudit || plan === 'SUPP' || !isEnablebyRole
                            }
                          />
                        }
                        label="Reimbursed amount less than % allowed"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="percent_allowed_amounts"
                      label="Percent Allowed Amounts"
                      fullWidth
                      placeholder=""
                      className="mandate-fields"
                      value={data?.CRLAtestAmt}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value && value.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(value))
                            changeHandler(value, 'CRLAtestAmt');
                          else return false;
                        } else if (RX_WITHOUT.test(value))
                          changeHandler(value, 'CRLAtestAmt');
                        else return false;
                      }}
                      data-testid="CRLAtestAmt"
                      disabled={
                        defAudit ||
                        !data.CSRAtestOnInd ||
                        plan === 'SUPP' ||
                        !isEnablebyRole
                      }
                      InputProps={{
                        inputProps: {
                          maxlength: 15,
                          style: { textAlign: 'right' },
                        },
                        endAdornment: (
                          <InputAdornment className="prefix-symbol pr-2">
                            %
                          </InputAdornment>
                        ),
                      }}
                      inputProps={{
                        maxLength: 20,
                        id: 'percentSubmittedAmount1',
                      }}
                      InputLabelProps={{ shrink: true }}
                      onBlur={(e) => blurHandler(e.target.value, 'CSRAtestAmt')}
                      helperText={
                        flderr?.CSRAtestAmtErr ? Messages.PER_SUB_ERR : null
                      }
                      error={flderr?.CSRAtestAmtErr}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            value={data?.CSTRtestOnInd === 1}
                            checked={data?.CSTRtestOnInd === 1}
                            onChange={(e, val) =>
                              changeHandler(val, 'CSTRtestOnInd', true)
                            }
                            data-testid="CSTRtestOnInd"
                            disabled={
                              defAudit || plan === 'SUPP' || !isEnablebyRole
                            }
                          />
                        }
                        label="Amount submitted greater than threshold"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="threshold_amount"
                      label="Threshold Amount   "
                      fullWidth
                      className="mandate-fields dollar-symbol"
                      placeholder=""
                      value={data?.CSTRtestAmt}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value && value?.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(value))
                            changeHandler(value, 'CSTRtestAmt');
                          else return false;
                        } else if (RX_WITHOUT.test(value))
                          changeHandler(value, 'CSTRtestAmt');
                        else return false;
                      }}
                      data-testid="CSTRtestAmt"
                      disabled={
                        defAudit ||
                        !data.CSTRtestOnInd ||
                        plan === 'SUPP' ||
                        !isEnablebyRole
                      }
                      inputProps={{
                        maxLength: 20,
                        id: 'thresholdAmount',
                      }}
                      InputProps={{
                        inputProps: {
                          maxLength: 20,
                          style: { textAlign: 'right' },
                        },
                        // inputComponent: NumberFormatCustom,
                        startAdornment: (
                          <InputAdornment className="prefix-symbol">
                            $
                          </InputAdornment>
                        ),
                        id: 'thresholdAmount',
                      }}
                      InputLabelProps={{ shrink: true }}
                      onBlur={(e) => blurHandler(e.target.value, 'CSTRtestAmt')}
                      helperText={
                        flderr?.CSTRtestAmtErr ? Messages.THRES_AMT_ERR : null
                      }
                      error={flderr?.CSTRtestAmtErr}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="no-margin min-md">
                  <div className="sub-radio text-black sub-label disable-chk">
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          value={data?.CIDCtestOnInd === 1}
                          checked={data?.CIDCtestOnInd === 1}
                          onChange={(e, val) =>
                            changeHandler(val, 'CIDCtestOnInd', true)
                          }
                          disabled={
                            defAudit || plan === 'SUPP' || !isEnablebyRole
                          }
                        />
                      }
                      data-testid="CIDCtestOnInd"
                      label="Identify duplicate claims"
                      labelPlacement="end"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3" />
            </div>
          </div>
        </fieldset>
        <fieldset className="custom-fieldset">
          <legend className="same-font-family">Invoice</legend>
          <form autoComplete="off">
            <div className="off">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form no-margin min-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              value={data?.IUNPtestOnInd === 1}
                              checked={data?.IUNPtestOnInd === 1}
                              onChange={(e, val) =>
                                changeHandler(val, 'IUNPtestOnInd', true)
                              }
                              disabled={defAudit || !isEnablebyRole}
                            />
                          }
                          data-testid="IUNPtestOnInd"
                          label="Units greater than % prior quarter"
                          labelPlacement="end"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form with-select input-md override-width-95">
                      <TextField
                        id="percent_prior_qurater1"
                        label="Percent Prior Quarter"
                        fullWidth
                        placeholder=""
                        className="mandate-fields"
                        inputProps={{ maxLength: 30 }}
                        InputLabelProps={{ shrink: true }}
                        disabled={
                          defAudit || !data.IUNPtestOnInd || !isEnablebyRole
                        }
                        value={data?.IUNPtestPct}
                        onChange={(e) => {
                          const { value } = e.target;
                          if (value && value.includes('.')) {
                            if (TWO_DECIMAL_REGEX.test(value))
                              changeHandler(value, 'IUNPtestPct');
                            else return false;
                          } else if (RX_WITHOUT.test(value))
                            changeHandler(value, 'IUNPtestPct');
                          else return false;
                        }}
                        InputProps={{
                          inputProps: {
                            maxlength: 30,
                            style: { textAlign: 'right' },
                          },
                          endAdornment: (
                            <InputAdornment className="prefix-symbol pr-2">
                              %
                            </InputAdornment>
                          ),
                          id: 'percentPriorQuarter1',
                        }}
                        data-testid="IUNPtestPct"
                        onBlur={(e) =>
                          blurHandler(e.target.value, 'IUNPtestPct')
                        }
                        helperText={
                          flderr?.IUNPtestPctErr ? Messages.PER_PRIOR_ERR : null
                        }
                        error={flderr?.IUNPtestPctErr}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form no-margin min-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              value={data?.IRGRtestOnInd === 1}
                              checked={data?.IRGRtestOnInd === 1}
                              onChange={(e, val) =>
                                changeHandler(val, 'IRGRtestOnInd', true)
                              }
                              data-testid="IRGRtestOnInd"
                              disabled={defAudit || !isEnablebyRole}
                            />
                          }
                          data-testid="IRGRtestOnInd"
                          label="Rebate charged greater than % reimbursed amount"
                          labelPlacement="end"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form with-select input-md override-width-95">
                      <TextField
                        id="percent_reimbursed_amount"
                        label="Percent Reimbursed Amount"
                        fullWidth
                        placeholder=""
                        className="mandate-fields"
                        inputProps={{
                          maxLength: 20,
                          id: 'percentReimbursedAmount',
                        }}
                        InputProps={{
                          inputProps: {
                            maxlength: 20,
                            style: { textAlign: 'right' },
                          },
                          endAdornment: (
                            <InputAdornment className="prefix-symbol pr-2">
                              %
                            </InputAdornment>
                          ),
                          id: 'percentPriorQuarter2',
                        }}
                        InputLabelProps={{ shrink: true }}
                        disabled={
                          defAudit || !data.IRGRtestOnInd || !isEnablebyRole
                        }
                        value={data?.IRGRtestPct}
                        onChange={(e) => {
                          const { value } = e.target;
                          if (value && value.includes('.')) {
                            if (TWO_DECIMAL_REGEX.test(value))
                              changeHandler(value, 'IRGRtestPct');
                            else return false;
                          } else if (RX_WITHOUT.test(value))
                            changeHandler(value, 'IRGRtestPct');
                          else return false;
                        }}
                        data-testid="IRGRtestPct"
                        onBlur={(e) =>
                          blurHandler(e.target.value, 'IRGRtestPct')
                        }
                        helperText={
                          flderr?.IRGRtestPctErr
                            ? Messages.PER_REB_AMT_ERR
                            : null
                        }
                        error={flderr?.IRGRtestPctErr}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form no-margin min-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              value={data?.IRGPtestOnInd === 1}
                              checked={data?.IRGPtestOnInd === 1}
                              onChange={(e, val) =>
                                changeHandler(val, 'IRGPtestOnInd', true)
                              }
                              disabled={defAudit || !isEnablebyRole}
                            />
                          }
                          data-testid="IRGPtestOnInd"
                          label="Rebate for this NDC exceeds % rebate for previous quarter"
                          labelPlacement="end"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form with-select input-md override-width-95">
                      <TextField
                        id="percent_prior_qurater2"
                        label="Percent Prior Quarter"
                        fullWidth
                        placeholder=""
                        className="mandate-fields"
                        inputProps={{ maxLength: 30 }}
                        InputLabelProps={{ shrink: true }}
                        disabled={
                          defAudit || !data.IRGPtestOnInd || !isEnablebyRole
                        }
                        value={data?.IRGPtestPct}
                        onChange={(e) => {
                          const { value } = e.target;
                          if (value && value.includes('.')) {
                            if (TWO_DECIMAL_REGEX.test(value))
                              changeHandler(value, 'IRGPtestPct');
                            else return false;
                          } else if (RX_WITHOUT.test(value))
                            changeHandler(value, 'IRGPtestPct');
                          else return false;
                        }}
                        data-testid="IRGPtestPct"
                        InputProps={{
                          inputProps: {
                            maxlength: 30,
                            style: { textAlign: 'right' },
                          },
                          endAdornment: (
                            <InputAdornment className="prefix-symbol pr-2">
                              %
                            </InputAdornment>
                          ),
                          id: 'percentPriorQuarter2',
                        }}
                        onBlur={(e) =>
                          blurHandler(e.target.value, 'IRGPtestPct')
                        }
                        helperText={
                          flderr?.IRGPtestPctErr ? Messages.PER_PRIOR_ERR : null
                        }
                        error={flderr?.IRGPtestPctErr}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form no-margin min-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              value={data?.IRGLtestOnInd === 1}
                              checked={data?.IRGLtestOnInd === 1}
                              onChange={(e, val) =>
                                changeHandler(val, 'IRGLtestOnInd', true)
                              }
                              disabled={defAudit || !isEnablebyRole}
                            />
                          }
                          data-testid="IRGLtestOnInd"
                          label="Rebate for this labeler exceeds % rebate for previous quarter"
                          labelPlacement="end"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form with-select input-md override-width-95">
                      <TextField
                        id="percent_prior_qurater3"
                        label="Percent Prior Quarter"
                        fullWidth
                        placeholder=""
                        className="mandate-fields"
                        inputProps={{ maxLength: 30 }}
                        InputLabelProps={{ shrink: true }}
                        disabled={
                          defAudit || !data.IRGLtestOnInd || !isEnablebyRole
                        }
                        value={data?.IRGLtestPct}
                        InputProps={{
                          inputProps: {
                            maxlength: 30,
                            style: { textAlign: 'right' },
                          },
                          endAdornment: (
                            <InputAdornment className="prefix-symbol pr-2">
                              %
                            </InputAdornment>
                          ),
                          id: 'percentPriorQuarter3',
                        }}
                        onChange={(e) => {
                          const { value } = e.target;
                          if (value && value.includes('.')) {
                            if (TWO_DECIMAL_REGEX.test(value))
                              changeHandler(value, 'IRGLtestPct');
                            else return false;
                          } else if (RX_WITHOUT.test(value))
                            changeHandler(value, 'IRGLtestPct');
                          else return false;
                        }}
                        data-testid="IRGLtestPct"
                        onBlur={(e) =>
                          blurHandler(e.target.value, 'IRGLtestPct')
                        }
                        helperText={
                          flderr?.IRGLtestPctErr ? Messages.PER_PRIOR_ERR : null
                        }
                        error={flderr?.IRGLtestPctErr}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      </div>
    </>
  );
};
export default AuditsTab;
